// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"268f9a1d","315":"0f4494c2","434":"e3969431","787":"197e8d12"}[chunkId] + ".chunk.js";
};